// extracted by mini-css-extract-plugin
module.exports = {"container":"search-input_container__dlep7","input":"search-input_input__Qwtve"};